import { Instagram } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import logo from './assets/Logo_2.png';

export default function Footer() {
  return (
    <footer className="bg-gray-50 pt-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <hr className="border-t border-gray-300" style={{ borderWidth: '0.5px' }} />
      </div>

      <div className="max-w-7xl mx-auto py-8 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img
            src={logo}
            alt="Company Logo"
            className="w-20 h-20 md:w-32 md:h-32 object-contain"
          />
        </div>

        <div
          className="text-gray-600 text-xs md:text-sm font-medium"
          style={{ fontFamily: 'Mulish, sans-serif' }}
        >
          © 2026. ALL RIGHTS RESERVED
        </div>

        <div className="flex items-center gap-4">
          <a href="https://www.instagram.com/behzadlifts/" target="_
          blank" rel="noopener noreferrer" className="hover:opacity-70 transition-opacity">
            <Instagram className="w-6 h-6 text-gray-800" />
          </a>
          <button
            onClick={() => window.open(`https://wa.me/03194622938?text=${encodeURIComponent('Hi! I am interested in your powerlifting services. Please provide more information about your training programs, pricing, and availability.')}`, '_blank')}
            className="hover:opacity-70 transition-opacity bg-transparent border-none cursor-pointer p-0"
          >
            <FaWhatsapp className="w-6 h-6 text-gray-800" size={24} />
          </button>
        </div>
      </div>
    </footer>
  );
}
